import React from 'react';
import { isLollySkin } from '@utils/index';

interface BlockedIconProps {
  className?: string;
  size?: number;
}

export const BlockedIcon: React.FC<BlockedIconProps> = ({ 
  className = '', 
  size = 63 
}) => {
  const strokeColor = isLollySkin() ? '#ded8cd' : ' #e4e2dc';
  
  return (
    <svg 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      version="1.1" 
      viewBox="0 0 62.67 139.33"
      width={size}
      height={size * (139.33 / 62.67)}
      className={className}
    >
      <defs>
        <style>
          {`.st0 {
            fill: none;
            stroke: ${strokeColor};
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 7px;
          }`}
        </style>
      </defs>
      <polygon className="st0" points="38.22 86.41 23.65 86.41 20.65 18.95 41.22 18.95 38.22 86.41"/>
      <rect className="st0" x="22.55" y="103.44" width="15.78" height="15.78"/>
    </svg>
  );
};
